<script setup lang="ts">
/**
 * Error page for `ErrorCode.NoFragmentInAuthResponse` — the OAuth callback
 * URL contained no fragment (`#`) component. Keycloak returns the auth code
 * in the fragment when `response_mode=fragment`; its absence means the
 * callback was malformed or intercepted. Delegates all rendering to
 * `AuthErrorView`.
 */
import AuthErrorView from '@/components/errors/AuthErrorView.vue'
import { ErrorCode } from '@/errors/codes'
</script>

<template>
  <AuthErrorView :code="ErrorCode.NoFragmentInAuthResponse" />
</template>
